import { useIntl } from 'react-intl';
import { TableFooterCell } from './Table.css';

type ReportedDay = {
  date: string;
  dayOfWeek?: string;
  holiday?: boolean;
  bankHoliday?: boolean;
  // Saved amount as the report form shows it: '' for an empty day.
  hours?: number | string | null;
};

const isWorkingDay = (day: ReportedDay) =>
  day.dayOfWeek !== 'SATURDAY' &&
  day.dayOfWeek !== 'SUNDAY' &&
  !day.holiday &&
  !day.bankHoliday;

// B2B and civil-contract consultants have no day-off category: a working day
// saved with 0 hours is a day without work. It counts calendar days, so a day
// split across entries counts once and only when all of them are 0 hours; an
// empty day stays unreported and is not counted.
export const countDaysWithoutWork = (days: ReportedDay[]) => {
  const hoursByDate = new Map<string, number>();
  days.filter(isWorkingDay).forEach(({ date, hours }) => {
    if (hours === '' || hours === null || hours === undefined) {
      return;
    }
    const amount = Number(hours);
    if (Number.isNaN(amount)) {
      return;
    }
    hoursByDate.set(date, (hoursByDate.get(date) ?? 0) + amount);
  });
  return Array.from(hoursByDate.values()).filter((total) => total === 0).length;
};

export const DaysWithoutWorkCounterCell = ({
  days,
}: {
  days: ReportedDay[];
}) => {
  const intl = useIntl();

  return (
    <TableFooterCell>
      {`${intl.formatMessage({
        id: 'SUMMARY.DAYS_WITHOUT_WORK',
      })}: ${countDaysWithoutWork(days)}`}
    </TableFooterCell>
  );
};
